<template>
  <app-modal ref="modal">
    <div class="modal-container flex-column u-typography-helvetica u-text u-text--s">
      <div class="content">
        <div class="content__message">
          <i18n tag="p" path="webshopAccess.offlineOnlyDoctor.warning">
            <span class="text-bold">{{ doctorFullName }}</span>
          </i18n>
          <p>{{ $t('webshopAccess.offlineOnlyDoctor.contactSupport') }}</p>
        </div>

        <div class="content__doctor-info flex--column--space-between">
          <p class="text-bold">{{ doctorFullName }}</p>
          <p>{{ doctorPhone }}</p>
          <a :href="mailToLink" class="text-link">{{ doctorEmail }}</a>
        </div>

        <div class="content__company-info flex--column--space-between">
          <span class="text-bold">{{ $t('webshopAccess.universkinSupport') }}</span>
          <a href="mailto:info@universkin.com" class="text-link">info@universkin.com</a>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { mapState } from 'vuex';

import AppModal from '@/components/common/AppModal.vue';

import { types } from '@/store/types';

import { COUNTRY_PHONES_MAP } from '@/constants/countries';

export default {
  name: 'PreventWebshopAccessModal',
  components: { AppModal },
  computed: {
    ...mapState({
      initialPageData: types.state.INITIAL_PAGE_DATA
    }),
    doctorFullName() {
      if (!this.initialPageData) {
        return '';
      }

      return this.initialPageData.doctorFullName;
    },
    doctorPhone() {
      if (!this.initialPageData) {
        return '';
      }

      const { doctorPhoneIso, doctorPhone } = this.initialPageData;
      const phoneIso = COUNTRY_PHONES_MAP[doctorPhoneIso].dialCode;

      return `+ ${phoneIso} ${doctorPhone}`;
    },
    doctorEmail() {
      if (!this.initialPageData) {
        return '';
      }

      return this.initialPageData.doctorEmail;
    },
    mailToLink() {
      return `mailto:${this.doctorEmail}`;
    }
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
  position: relative;
  width: 90vw;
  padding: 70px 0 40px;
  background-color: var(--u-color-white);
}

.content {
  width: 90%;
  margin: 0 auto;

  &__message,
  &__doctor-info {
    margin-bottom: 20px;
  }
}

.text-link {
  color: var(--u-color-black-5);
  text-decoration: underline;
}

@media (min-width: 600px) {
  .modal-container {
    padding: 80px 0 50px;
    width: 70vw;
    max-width: 550px;
    max-height: 430px;
  }

  .content {
    width: 80%;
  }
}

@media (min-width: 960px) {
  .modal-container {
    padding: 110px 0 50px;
    max-width: 670px;
  }

  .content {
    max-width: 570px;

    &__message,
    &__doctor-info {
      margin-bottom: 24px;
    }
  }
}
</style>
